const Error = 'Error';
const Warning = 'Warning';
const Publishing = 'Publishing';
const Success = 'Success';
const CouldNotRun = 'CouldNotRun';

const PublishStatusType = Object.freeze({
    [Error]: 1,
    [Warning]: 2,
    [Publishing]: 3,
    [Success]: 4,
    [CouldNotRun]: 5,
});

export const PublishStatusClassNames = Object.freeze({
    1: 'status-error',
    2: 'status-warning',
    3: 'status-publishing',
    4: 'status-success',
    5: '',
});

export default PublishStatusType;
